<template lang="pug">
modal(id="clone-grid", ref="modal", :loading="onLoading('clone-order-layout')")
    template(slot="title") Copy Grid Layout
    template(slot="footer")
        button.btn.btn-fw.primary(@click="submit" :disabled="onLoading('clone-order-layout')")
            v-loading(loader="clone-order-layout") Copy
    template(slot="body")
        form(@submit.prevent="submit", v-if="orderLayout !== null")
            fieldset(:disabled="onLoading('clone-order-layout')")
                .col-md-12
                    p.m-b-0 Copy 
                        span._500 {{ orderLayout.name }} 
                        | grid layout to :

                    .md-form-group
                        label._500 Select Outlet
                        select.md-input(v-model="orderLayout.outlet_id", v-validate="'required'", name="outlet")
                            option(:value="null", disabled) Select Outlet
                            option(:value="outlet.id", v-for="outlet in outletList", :key="outlet.id") {{ outlet.name }}
                        span.text-danger.block(v-show="errors.has('outlet')") {{ errors.first('outlet') }}
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            orderLayout: null,
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),
    },

    mounted() {
        OrderLayoutEvent.$on('clone-order-layout', orderLayout => {
            this.orderLayout = orderLayout;
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('orderLayout', ['cloneOrderLayout']),

        async submit() {
            const validate = await this.$validator.validateAll();
            if (!validate) return;

            this.startLoading('clone-order-layout');

            try {
                const orderLayout = await this.cloneOrderLayout(
                    this.orderLayout,
                );
                location.href = Laroute.route('franchise.order_layout.show', {
                    id: orderLayout.id,
                });
            } catch (e) {
                this.endLoading('clone-order-layout');
                swal({
                    type: 'error',
                    title: 'Oops...',
                    text: e,
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-clone.vue